import { Controller, useFormContext } from "react-hook-form";

function TextField({
  name,
  label,
  type,
  required,
  requiredText = "This field is required",
  disabled,
  validation,
  subtext,
  placeholder,
  suggestions,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const rules = {
    ...(required && { required: requiredText }),
    ...(validation && { validate: validation }),
  };
  // A datalist gives the browser's own autosuggest: values filter as you type
  // and can be picked, but anything else can still be typed in.
  const listId = suggestions?.length ? `${name}-suggestions` : undefined;
  return (
    <fieldset>
      <label>
        {label}
        {!required && <span className="label-optional"> (Optional)</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <input
            type={type}
            disabled={disabled}
            onWheel={(e) => e.target.blur()}
            placeholder={placeholder}
            list={listId}
            {...field}
          />
        )}
      />
      {listId && (
        <datalist id={listId}>
          {suggestions.map((suggestion) => (
            <option key={suggestion} value={suggestion} />
          ))}
        </datalist>
      )}
      <small>{subtext}</small>
      <span className="input-error">{errors?.[name]?.message}</span>
    </fieldset>
  );
}

export default TextField;
